<template>
  <component :is="activeComponent" />
</template>

<script>
import OneOnOneUser from './OneOnOneUser.vue'
import OneOnOneManager from './OneOnOneManager.vue'

export default {
  name: 'OneOnOne',

  components: {
    OneOnOneUser,
    OneOnOneManager,
  },

  computed: {
    activeComponent() {
      const user = this.getCurrentUser()
      if (user && user.role === 'MANAGER') {
        return 'OneOnOneManager'
      }
      return 'OneOnOneUser'
    },
  },

  methods: {
    getCurrentUser() {
      try {
        const userStr = localStorage.getItem('user')
        return userStr ? JSON.parse(userStr) : null
      } catch (error) {
        return null
      }
    },
  },
}
</script>
